(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6456],{

/***/ 96456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ components_PowerYourApps_PowerYourApps; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Engineering/components/PowerYourApps/assets/PowerYourApps@2x.png
var PowerYourApps_2x = __webpack_require__(90922);
var PowerYourApps_2x_default = /*#__PURE__*/__webpack_require__.n(PowerYourApps_2x);
// EXTERNAL MODULE: ./src/views/Engineering/components/PowerYourApps/assets/PowerYourApps.webp
var PowerYourApps = __webpack_require__(96051);
var PowerYourApps_default = /*#__PURE__*/__webpack_require__.n(PowerYourApps);
// EXTERNAL MODULE: ./src/views/Engineering/components/PowerYourApps/assets/PowerYourApps@2x.webp
var assets_PowerYourApps_2x = __webpack_require__(64153);
var assets_PowerYourApps_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PowerYourApps_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Engineering/components/PowerYourApps/PowerYourAppsImage.tsx







var PowerYourAppsImage = function PowerYourAppsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((PowerYourApps_default()), ", ").concat((assets_PowerYourApps_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (PowerYourApps_2x_default()),
      alt: "Power Your Apps",
      width: "616",
      height: "640",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var PowerYourApps_PowerYourAppsImage = (PowerYourAppsImage);
;// CONCATENATED MODULE: ./src/views/Engineering/components/PowerYourApps/PowerYourApps.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  heading: "Power all your apps with the same data",
  description: "Integrate your data to ".concat("450", "+ apps with just a few clicks.")
};
var PowerYourApps_link = {
  text: "Explore Tracking API",
  url: "https://segment.com/docs/connections/spec/track/"
};
var features = [{
  heading: "Activate any tool instantly",
  description: "Integrate new tools in minutes, not weeks. No more setup headaches, no need to push code.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* IntegrationIcon */.iX, {})
}, {
  heading: "Make your mobile integrations agile",
  description: "No more waiting for App Store approval. Turn on new tools instantly, even ones without their own mobile SDK.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* MobileIcon */.xO, {})
}, {
  heading: "Remove vendor lock-in",
  description: "Segment simplifies trying new solutions, eliminating expensive integration barriers to using top tools.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* SafeIcon */.zQ, {})
}];

var PowerYourApps_PowerYourApps = function PowerYourApps() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            variant: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: PowerYourApps_link.url,
            children: PowerYourApps_link.text
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            gap: "small",
            children: features.map(function (feature) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBoxComponent, {
                alignment: "left",
                headerPosition: "left",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                    elevation: 1,
                    variant: "circle",
                    children: feature.icon
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    children: feature.heading
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                    children: feature.description
                  })]
                })]
              }, feature.heading);
            })
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PowerYourApps_PowerYourAppsImage, {})
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1bxhfjq2"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var FeatureBoxComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e1bxhfjq1"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.between("sm", "md");
}, "{", FeatureBox/* CSSHeaderPositionTop */.Hq, ";}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bxhfjq0"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var components_PowerYourApps_PowerYourApps = (PowerYourApps_PowerYourApps);
;// CONCATENATED MODULE: ./src/views/Engineering/components/PowerYourApps/index.ts


/***/ }),

/***/ 90922:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerYourApps@2x-ab222a051e2859678dbcf93a4a1a54b7.png";

/***/ }),

/***/ 96051:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerYourApps-d8fa6ad84f1043beb67061cf9a6db9bd.webp";

/***/ }),

/***/ 64153:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerYourApps@2x-ab222a051e2859678dbcf93a4a1a54b7.webp";

/***/ })

}]);